module.exports = __webpack_public_path__ + "static/media/fra-earnings.f2d5705f.svg";